import Logger from '@tools/logger/logger';
import requests from '@tools/requests-mixin';

export default {
  mixins: [ requests ],
  methods: {
    /**
     * Enable Setting
     */
    enableUserSetting(settingURL) {
      this.post(settingURL).catch((error) => Logger.error(error));
    },
  },
};
